import { useEffect } from "react";
import { useStopwatch } from "core/providers/StopwatchContext";

import { getTodayKey } from "../utils/sessionStorage";
import { workSessionService } from "../api/work-session.service";

type Params = {
  collaboratorId?: number;
  projectId?: number;
  phaseId?: string | number;
  blockId?: string | number;
  stageId?: string | number;
};

export function useProjectAccumulatedTime({
  collaboratorId,
  projectId,
  phaseId,
  blockId,
  stageId,
}: Params) {
  const { setProjectAccumulatedSeconds } = useStopwatch();

  useEffect(() => {
    if (!collaboratorId || !projectId || !phaseId || !blockId || !stageId) {
      setProjectAccumulatedSeconds(0);
      return;
    }

    let cancelled = false;

    const fetchAccumulated = async () => {
      try {
        const response = await workSessionService.getAccumulated({
          collaborator_id: collaboratorId,
          hub_project_id: projectId,
          hub_phase_id: phaseId,
          hub_block_id: blockId,
          hub_stage_id: stageId,
          date: getTodayKey(),
        });

        if (cancelled) return;

        setProjectAccumulatedSeconds(response.total_seconds ?? 0);
      } catch (err) {
        console.error(err);
        if (!cancelled) setProjectAccumulatedSeconds(0);
      }
    };

    fetchAccumulated();

    return () => {
      cancelled = true;
    };
  }, [
    collaboratorId,
    projectId,
    phaseId,
    blockId,
    stageId,
    setProjectAccumulatedSeconds,
  ]);
}
